export default __webpack_public_path__ + "img/bf21f02babfec1df101a0b4de353507b.svg";